import { render } from "./BaseInput.vue?vue&type=template&id=b0be89ac"
import script from "./BaseInput.vue?vue&type=script&lang=js"
export * from "./BaseInput.vue?vue&type=script&lang=js"

import "./BaseInput.vue?vue&type=style&index=0&id=b0be89ac&lang=css"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__